import columns from '../../../../../react-table/helpers/columns';
import { sumTotal, sumRoundedTotal } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    DateTimeColumn,
    FloatColumn,
    NumberColumn,
    TextColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  function countNetGrossWithColumn(header, formatOfContent) {
    return {
      Header: header,
      columns: [
        new NumberColumn(
          'Count',
          `despatchParticularFormatOfContentsSummary.${formatOfContent}.receptacleCount`,
        ).withTotalHeader(sumTotal),
        new FloatColumn(
          'Net',
          `despatchParticularFormatOfContentsSummary.${formatOfContent}.totalNetWeight`,
        ).withTotalHeader(sumRoundedTotal),
        new FloatColumn(
          'Gross',
          `despatchParticularFormatOfContentsSummary.${formatOfContent}.totalGrossWeight`,
        ).withTotalHeader(sumRoundedTotal),
      ],
    };
  }

  return [
    {
      Header: '',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn(
          'Despatch ID',
          'predesWithDespatchS8IdAndLastTransportLeg.despatchS8Id',
        ).withWidth(210).withTotalHeader('Total')),
      ],
    },
    {
      Header: 'Last leg',
      columns: [
        new TextColumn(
          'Conveyance reference',
          'predesWithDespatchS8IdAndLastTransportLeg.lastTransportLeg.name',
        ).withWidth(155),
        new DateTimeColumn(
          'Planned arrival date',
          'predesWithDespatchS8IdAndLastTransportLeg.lastTransportLeg.scheduledLocalDateTime',
        ).withWidth(145),
      ],
    },
    countNetGrossWithColumn('Small', 'small'),
    countNetGrossWithColumn('Large', 'large'),
    countNetGrossWithColumn('Bulky', 'bulky'),
    countNetGrossWithColumn('Other', 'other'),
    countNetGrossWithColumn('Totals', 'total'),
  ];
};

